var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_509_17430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 5.00033H5.00833M5 15.0003H5.00833M4.33333 8.33366H15.6667C16.6001 8.33366 17.0668 8.33366 17.4233 8.152C17.7369 7.99221 17.9919 7.73725 18.1517 7.42364C18.3333 7.06712 18.3333 6.60041 18.3333 5.66699V4.33366C18.3333 3.40024 18.3333 2.93353 18.1517 2.57701C17.9919 2.2634 17.7369 2.00844 17.4233 1.84865C17.0668 1.66699 16.6001 1.66699 15.6667 1.66699H4.33333C3.39991 1.66699 2.9332 1.66699 2.57668 1.84865C2.26308 2.00844 2.00811 2.2634 1.84832 2.57701C1.66667 2.93353 1.66667 3.40024 1.66667 4.33366V5.66699C1.66667 6.60041 1.66667 7.06712 1.84832 7.42364C2.00811 7.73725 2.26308 7.99221 2.57668 8.152C2.9332 8.33366 3.39991 8.33366 4.33333 8.33366ZM4.33333 18.3337H15.6667C16.6001 18.3337 17.0668 18.3337 17.4233 18.152C17.7369 17.9922 17.9919 17.7372 18.1517 17.4236C18.3333 17.0671 18.3333 16.6004 18.3333 15.667V14.3337C18.3333 13.4002 18.3333 12.9335 18.1517 12.577C17.9919 12.2634 17.7369 12.0084 17.4233 11.8486C17.0668 11.667 16.6001 11.667 15.6667 11.667H4.33333C3.39991 11.667 2.9332 11.667 2.57668 11.8486C2.26308 12.0084 2.00811 12.2634 1.84832 12.577C1.66667 12.9335 1.66667 13.4002 1.66667 14.3337V15.667C1.66667 16.6004 1.66667 17.0671 1.84832 17.4236C2.00811 17.7372 2.26308 17.9922 2.57668 18.152C2.9332 18.3337 3.39991 18.3337 4.33333 18.3337Z",
    stroke: "currentColor",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_509_17430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/server.4016c9dcc0d57d31129dab3a39c68f42.svg";
export { ForwardRef as ReactComponent };